<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>DANH SÁCH ĐIỀU CHỈNH SỐ LƯỢNG VẬT TƯ</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          v-if="dataPermission.includes('CNPS_DEVICE_ORDER_BALANCE_CREATE')"
          @click="create"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-plus-circle"></i><span>&nbsp;</span>Thêm mới
        </button>
        <button
          v-if="dataPermission.includes('CNPS_DEVICE_ORDER_BALANCE_VIEW')"
          @click="exportExcel"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-download"></i><span>&nbsp;</span>Xuất excel
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.createdTime"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.billNumber"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã phiếu"
              @keyup.enter="submitForm()"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.createdBy"
              :options="Config.getSearch(dataManager)"
              placeholder="Người tạo"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.inventoryId"
              :options="Config.getSearch(optionInventory)"
              placeholder="Tên kho"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="dataStatus"
              placeholder="Trạng thái"
            ></Select2>
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(time)="data">
                <p><b>Tạo:</b> {{ data.item.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}</p>
                <p><b>Duyệt:</b> {{ data.item.timeApprove | formatDate('HH:mm, DD/MM/YYYY') }}</p>
              </template>
              <template #cell(creator)="data">
                <p>{{ data.item.userCreator ? data.item.userCreator.name : '' }}</p>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.status || '']">
                  {{ data.item.status | transformData(dataStatus) }}
                </span>
                <span v-if="data.item.reasonReject"
                  >Lý do từ chối: {{ data.item.reasonReject }}</span
                >
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    v-if="dataPermission.includes('CNPS_DEVICE_ORDER_BALANCE_VIEW')"
                    @click="detail(data.item.id)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import { StaffService } from '@/services/staff.service'
  import mxItemAction from './mx-item-action.js'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import cloneDeep from 'lodash/cloneDeep'
  import moment from 'moment'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'billNumber', label: 'Mã phiếu', thStyle: 'min-width: 170px' },
    { key: 'time', label: 'Thời gian', thStyle: 'min-width: 170px' },
    { key: 'quantityImport', label: 'SL bổ sung', thStyle: 'min-width: 150px' },
    { key: 'quantityExport', label: 'SL giảm bớt', thStyle: 'min-width: 150px' },
    { key: 'inventoryNameExport', label: 'Kho', thStyle: 'min-width: 150px' },
    { key: 'creator', label: 'Người tạo', thStyle: 'min-width: 150px' },
    { key: 'status', label: 'Trạng thái', thStyle: 'min-width: 150px' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'quantity-material',
    mixins: [mxItemAction],
    data() {
      return {
        Config,
        fieldsTable,
        showLoading: false,
        filterTable: fieldsTable,
        tbLoading: false,
        lists: [],
        pagination: {
          total: 0,
        },
        search: {
          limit: 20,
          page: 1,
          createdTime: {},
        },
        optionInventory: [],
        dataManager: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        optionStatus: Config.statusDevices,
        dataStatus: [{ id: '0', text: 'Tất cả' }, ...Config.statusImportWarehouse],
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    created() {
      this.fetchData()
      DeviceService.infoWarehouse()
        .then(s => s.data?.map(s => ({ id: s.id, text: s.name })) ?? [])
        .then(s => (this.optionInventory = s))
      StaffService.getStaffByIdSuperior({ userId: this.dataUser.userId })
        .then(s => s.data?.map(s => ({ id: s.userId, text: `${s.name} - ${s.userName}` })) ?? [])
        .then(s => (this.dataManager = s))
    },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    methods: {
      preareData() {
        const data = cloneDeep(this.search)
        if (data.createdTime.endDate) {
          data.dateFrom = moment(data.createdTime.startDate).startOf('day').valueOf()
          data.dateTo = moment(data.createdTime.endDate).endOf('day').valueOf()
        }
        delete data.createdTime
        return data
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = this.preareData()
          const response = await DeviceService.getListQuantityMaterial(params)
          if (response.code === 1000) {
            this.lists = response.data.orders
            this.pagination.total = response.data.count
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.tbLoading = false
        }
      },
      async submitForm() {
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
          createdTime: {
            startDate: null,
            endDate: null,
          },
        }
        await this.fetchData()
      },
      create() {
        this.$router.push({ path: '/quantity-material/add' })
      },
      async exportExcel() {
        try {
          const params = this.preareData()
          delete params.limit
          delete params.page
          this.showLoading = true
          await DeviceService.exportQuantityMaterial(params)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style></style>
